<div class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4">
    <div class="flex items-start justify-between">
        <div class="text-xl font-medium tracking-tight leading-6 truncate">Val. media Premoney per Batch
        </div>

    </div>
    <div class="flex w-full items-center flex-auto mt-6 h-auto">
        <app-dashboard-chart
                class="w-full h-120"
                [chartData]="premoneyAvgforBatchChart"></app-dashboard-chart>
    </div>
</div>
